<template>
  <default-layout>
    <div class="l-main-layout">

      <div class="login-container">
        <div>
          <div class="login-form">
            <h1 class="t-medium mb">Login</h1>
            <div class="field">
              <label>Email</label>
              <input type="text" name="email" v-model="email" />
            </div>
            <div class="field">
              <label>Password</label>
              <input type="password" name="password" v-model="password" />
            </div>
            <div class="error">
              {{error}}
            </div>
            <div class="login-actions">
              <button class="button button--white" @click="authenticate">Login</button>
            </div>
          </div>
          <div class="google-btn" @click="getToken">
            <div class="google-icon-wrapper">
              <img src="../assets/images/logos/google_logo.svg" alt="Google Logo" class="google-icon-svg"/>
            </div>
            <p class="btn-text"><b>Sign in with Google</b></p>
          </div>
        </div>

      </div>

    </div>
  </default-layout>
</template>

<script>
import ApiAuth from '../utils/apiAuth';
import { store, mutations } from '../utils/store';

export default {
  data() {
    return {
      email: "",
      password: "",
      error: "",
      client: null
    }
  },

  mounted() {
    if (store.token) {
      this.$router.push("/")
    }
    this.loadGoogleOauth()
  },

  methods: {
    authenticate() {
      ApiAuth.post('/users/sign_in', 
        { // params
          user: {
            email: this.email,
            password: this.password,
          }
        }) 
        .then(response => {
          mutations.setToken(response.data.token);
          mutations.setRole(response.data.role);
          mutations.setEmail(response.data.email);
          window.location = "/"
        })
        .catch(error => {
          console.log(error)
          if (error.response && error.response.status == 401) {
            this.error = "Sorry, the username/password were not correct"  
          } else {
            this.error = "Sorry, there was a problem. Please try again"
          }
        });
    },

    loadGoogleOauth () {
      if (!window.google) {
        const script = document.createElement('script')
        script.onload = this.initClient
        script.type = 'text/javascript'
        script.src = 'https://accounts.google.com/gsi/client'
        document.head.appendChild(script)
      } else {
        this.initClient()
      }
    },

    initClient () {
      if (!this.client) {
        this.client = window.google.accounts.oauth2.initCodeClient({
          client_id: '613300734799-j4ies5bdmmsbe7hnucv0sbm6ausg8b9s.apps.googleusercontent.com',
          // scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
          scope: 'email profile',
          ux_mode: 'popup',
          // prompt: 'select_account'
          callback: (response) => {
            this.authorize(response.code)
          }
        })
      }
    },
    
    getToken () {
      this.client.requestCode()
    },

    authorize (code) {
      ApiAuth.get('/auth/google_oauth2/callback',
        {
          params: {
            code: code,
            redirect_uri: "postmessage"
          }
        },
        {
          json: true
        }
      )
        .then((response) => {
          mutations.setToken(response.data.token);
          mutations.setRole(response.data.role);
          mutations.setEmail(response.data.email);
          if (this.$route.query.return) {
            window.location = this.$route.query.return
          } else {
            window.location = "/"
          }
        })
        .catch((e) => {
          console.error(e)
          if (e && e.error && e.error === 'popup_closed_by_user') {
            return
          }
          const response = e.response
          if (response && response.status === 401) {
            this.error = 'Sorry, this account is not authorised'
          } else if (response && response.data && response.data.error) {
            this.error = response.data.error
          } else {
            this.error = 'Sorry there was a problem, please try again'
          }
        })
    }

  }
}
</script>

<style lang="scss">
  .login-container {
    margin: auto auto;
    display: flex;
    height: 70vh;
    align-items: center;
  }

  .field {
    margin-bottom: 20px;
    label {
      font-family: var(--f-semi);
      font-size: 13px;
      display: block;
      margin-bottom: 6px;
    }
    input {
      font-family: var(--f-semi);
      font-size: 13px;
      width: 250px;
      border: 1px solid black; 
      padding: 8px 12px;
      background-color: white;
    }
  }

  .login-actions {
    display: flex;
    justify-content: flex-end;
  }

  .error {
    font-family: var(--f-semi);
    color: darkred;
    line-height: 150%;
    width: 250px;
    margin-bottom: 20px;
    font-size: 13px;
  }
</style>
